import React, { useEffect, Fragment, useRef, useState } from "react";
import Quickview from "../../components/Quickview";
import Overview, { fetcher } from "../../components/Overview/Overview";
import { CourseOverviewDefinitionMissingInformation, CourseOverviewDefinitionOverdue, CoursesOverviewDefinitionDefault } from "./CoursesOverview";
import useSWR from "swr";

import cx from "classnames";
import { StudentOverviewBase, UserOverviewBase } from "../students/StudentOverview";

import { useDateFormInput } from "../../components/InputSelectors/useDateFormInput";
import { useAsyncFilter } from "../../components/InputSelectors/useAsyncFilter";
import { useSearchComponent } from "../../components/InputSelectors/useSearchComponent";
import * as constants from "../../constants";

export function SearchContact(props) {
    return (
        <>
            <Quickview>
                <Overview
                    quickview={{
                        identifier: "student-search",
                        name: "Zoek contactpersoon"
                    }}
                    identifier={"student-search"}
                    definition={UserOverviewBase}
                    onClick={(params) => {
                        if (props?.onClick && typeof props.onClick === "function") {
                            props?.onClick(params);
                        }
                    }}
                />
            </Quickview>
        </>
    );
}

export function SearchStudent(props) {
    return (
        <>
            <Quickview>
                <Overview
                    quickview={{
                        identifier: "student-search",
                        name: "Zoek cursist"
                    }}
                    identifier={"student-search"}
                    definition={StudentOverviewBase}
                    onClick={(params) => {
                        if (props?.onClick && typeof props.onClick === "function") {
                            props?.onClick(params);
                        }
                    }}
                />
            </Quickview>
        </>
    );
}

// Funcitonal component entrypoint for Courses
export function Courses(props) {
    const { data: trainerResult } = useSWR(() => "/v1/trainers/?limit=2&is_active=true", fetcher);

    const multipleTrainers = trainerResult?.count > 1;

    // NIBHV Contactpersoon (account_manager)
    const accountManagerFilter = useAsyncFilter({
        name: "NIBHV contactpersoon",
        identifier: "course-filter",
        columnIdentifier: "account_manager",
        endpoint: "/v1/users",
        endpointParams: [
            { key: "is_account_manager", value: true },
            { key: "pagination", value: false }
        ],
        placeholder: "Selecteer of typ een deel van de naam",
        value: "uuid",
        labels: ["full_name", "nibhv_number"],
        // minLength: 2,
        labelDef: (props) => `${props.full_name} (${props.nibhv_number})`
    });

    // NIBHV Contactpersoon (course_contact)
    const courseContactFilter = useAsyncFilter({
        name: "Cursus contactpersoon",
        identifier: "course-filter",
        columnIdentifier: "course_contact",
        endpoint: "/v1/users",
        endpointParams: [{ key: "pagination", value: false }],
        placeholder: "Typ een deel van de naam om te zoeken",
        value: "uuid",
        labels: ["full_name", "nibhv_number"],
        // Please note: below defaults to 2 as 0 is the most load-taxing, make sure to check if the queries take a long time
        minLength: !trainerResult ? 2 : multipleTrainers ? 2 : 0,
        labelDef: (props) => `${props.full_name} (${props.nibhv_number})`
    });

    // Instructeur
    const instructorFilter = useAsyncFilter({
        name: "Instructeur",
        columnIdentifier: "instructor",
        identifier: "course-filter",
        endpoint: "/v1/instructors",
        endpointParams: [
            { key: "is_active", value: true },
            { key: "pagination", value: false }
        ],
        value: "uuid",
        placeholder: "Selecteer of typ een deel van de naam",
        // label: "name",
        labels: ["full_name", "nibhv_number"],
        // minLength: 2,
        labelDef: (props) => `${props.full_name} (${props.nibhv_number})`
    });

    // Cursus:locatie
    const locationFilter = useAsyncFilter({
        name: "Cursuslocatie",
        columnIdentifier: "location",
        identifier: "course-filter",
        endpoint: "/v1/locations",
        endpointParams: [
            { key: "is_active", value: true },
            { key: "pagination", value: false }
        ],
        value: "uuid",
        // label: "name",
        labels: ["name", "street_name", "number", "postal_code", "city"],
        labelDef: (props) => `${props.name || ""} - ${props.street_name || ""} ${props.number || ""}, ${props.postal_code || ""}, ${props.city || ""}`,
        // minLength: 3,
        placeholder: "Typ een deel van de locatienaam, stad of postcode"
    });

    const fromDate = useDateFormInput({
        name: "Datum vanaf",
        columnIdentifier: "start_datetime_after",
        identifier: "course-filter",
        resultFormat: "DD-MM-YYYY 00:00:00", // date format passed to the server
        maxDate: "start_datetime_before", // field that's used to set the max date
    });

    const tillDate = useDateFormInput({
        name: "Datum tot en met",
        columnIdentifier: "start_datetime_before",
        identifier: "course-filter",
        resultFormat: "DD-MM-YYYY 23:59:59", // date format passed to the server
        minDate: "start_datetime_after", // field that's used to set the min date
    });

    const searchStudentContact = useSearchComponent({
        name: "Cursus cursist",
        title: "Zoek cursist",
        icon: "search",
        columnIdentifier: "uuid",
        resultColumnIdentifier: "student",
        identifier: "course-filter",
        Component: <SearchStudent />,
        resultDef: (props) => `${props.full_name} (${props.nibhv_number})`
    });

    const filters = [
        ...(multipleTrainers ? [accountManagerFilter] : []),
        instructorFilter,
        fromDate,
        tillDate,
        locationFilter,
        courseContactFilter,
        searchStudentContact
    ];

    const [filtersOpen, setFiltersOpen] = useState(false);

    // create a new ref which can be passed to Overview and which will contain a reference to the overview's mutate
    const overviewRef = useRef(false);

    const resetFilters = () => {
        filters.forEach((o) => o.reset());
        // overviewRef.current.resetFilters();
    };

    const disableState = (arr) => {
        return arr.map((c) => {
            if (c.columnIdentifier === "state") {
                return {
                    ...c,
                    FilterOptions: {
                        ...c.FilterOptions,
                        disabled: true
                    }
                };
            } else {
                return c;
            }
        });
    };

    const classNamePrefix = "overview-redux";

    return (
        <>
            <div className={`${classNamePrefix}-filters`}>
                <div className={`${classNamePrefix}-filters__controls`}>
                    <button className={`${classNamePrefix}-filters__toggle`} onClick={() => setFiltersOpen(!filtersOpen)}>
                        <i className={cx("fa", filtersOpen ? "fa-angle-down" : "fa-angle-right")} /> Filters
                    </button>
                    {filters.some((o) => o.result) && (
                        <button className={`${classNamePrefix}-filters__reset`} onClick={() => resetFilters()}>
                            Verwijder filters
                        </button>
                    )}
                </div>
                {filtersOpen && (
                    <div className={cx(`${classNamePrefix}-filters__inputs`, { [`${classNamePrefix}-filters__inputs--open`]: filtersOpen })}>
                        {filters.map((item, idx) => {
                            return (
                                <div key={item.title + "-" + idx} className={`${classNamePrefix}-filters__input`}>
                                    <label className={`${classNamePrefix}-filters__label`}>{item.name}:</label>
                                    {item.content}
                                </div>
                            );
                        })}
                    </div>
                )}
                <ul className={`${classNamePrefix}-filters__filters`}>
                    {filters
                        .filter((o) => o.result)
                        .map((item, idx) => {
                            return (
                                <li key={idx} className={`${classNamePrefix}-filters__filter`}>
                                    {item.result}
                                    <button onClick={() => item.reset()} className={`${classNamePrefix}-filters__filter-remove`}>
                                        <i className={"fa fa-times"} />
                                    </button>
                                </li>
                            );
                        })}
                </ul>
            </div>

            <Quickview
                initialIndex={0} // The quickview index to preselect onLoad
            >
                <Overview
                    classNamePrefix={classNamePrefix}
                    ref={overviewRef}
                    quickview={{
                        identifier: "courses-overview-all",
                        name: "Alle cursussen"
                    }}
                    identifier={"courses-overview-all"}
                    definition={{
                        ...CoursesOverviewDefinitionDefault,
                        columns: CoursesOverviewDefinitionDefault.columns.filter((c) => multipleTrainers || c.columnIdentifier !== "trainer_name"),
                        // topbar: CoursesOverviewDefinitionDefault.topbar.filter(s => multipleTrainers || s.columnIdentifier !== "trainer_name"),
                        defaults: {
                            ordering: {
                                columnIdentifier: "date",
                                direction: "-"
                            },
                            filter: {
                                ...CoursesOverviewDefinitionDefault.defaults.filter,
                                state: [constants.COURSE_STATE_OPEN, constants.COURSE_STATE_ENDED, constants.COURSE_STATE_FINISHED, constants.COURSE_STATE_CANCELLED],
                            }
                        }
                    }}
                    contextData={{
                        trainers: props?.state?.filterTrainers
                        // account_managers: props?.state?.filterAccountManagers,
                        // instructors: props?.state?.filterInstructors,
                        // locations: props?.state?.locations,
                    }}
                    forceFilter={filters
                        .filter((f) => f?.resultObj?.columnIdentifier /*&& f?.resultObj?.result*/)
                        .map((f) => {
                            return {
                                columnIdentifier: f?.resultObj?.columnIdentifier,
                                value: f?.resultObj?.result
                            };
                        })}
                />

                <Overview
                    classNamePrefix={classNamePrefix}
                    ref={overviewRef}
                    quickview={{
                        identifier: "courses-overview-default",
                        name: "Openstaand"
                    }}
                    identifier={"courses-overview"}
                    definition={{
                        ...CoursesOverviewDefinitionDefault,
                        columns: disableState(CoursesOverviewDefinitionDefault.columns.filter((c) => multipleTrainers || c.columnIdentifier !== "trainer_name"))
                        // topbar: CoursesOverviewDefinitionDefault.topbar.filter(s => multipleTrainers || s.columnIdentifier !== "trainer_name")
                    }}
                    contextData={{
                        trainers: props?.state?.filterTrainers
                        // account_managers: props?.state?.filterAccountManagers,
                        // instructors: props?.state?.filterInstructors,
                        // locations: props?.state?.locations,
                    }}
                    forceFilter={filters
                        .filter((f) => f?.resultObj?.columnIdentifier /*&& f?.resultObj?.result*/)
                        .map((f) => {
                            return {
                                columnIdentifier: f?.resultObj?.columnIdentifier,
                                value: f?.resultObj?.result
                            };
                        })}
                />

                <Overview
                    classNamePrefix={classNamePrefix}
                    ref={overviewRef}
                    quickview={{
                        identifier: "courses-overview-overdue",
                        name: "Nog af te ronden"
                    }}
                    identifier={"courses-overview-overdue"}
                    definition={{
                        ...CourseOverviewDefinitionOverdue,
                        columns: disableState(CourseOverviewDefinitionOverdue.columns.filter((c) => multipleTrainers || c.columnIdentifier !== "trainer_name"))
                        // topbar: CourseOverviewDefinitionOverdue.topbar.filter(s => multipleTrainers || s.columnIdentifier !== "trainer_name")
                    }}
                    contextData={{
                        trainers: props?.state?.filterTrainers
                        // account_managers: props?.state?.filterAccountManagers,
                        // instructors: props?.state?.filterInstructors,
                        // locations: props?.state?.locations,
                    }}
                    forceFilter={filters
                        .filter((f) => f?.resultObj?.columnIdentifier /*&& f?.resultObj?.result*/)
                        .map((f) => {
                            return {
                                columnIdentifier: f?.resultObj?.columnIdentifier,
                                value: f?.resultObj?.result
                            };
                        })}
                />

                <Overview
                    classNamePrefix={classNamePrefix}
                    ref={overviewRef}
                    quickview={{
                        identifier: "courses-overview-missing-info",
                        name: "Actie nodig",
                        prefixContent: props.state?.missingInfo > 0 ? <i className="fa fa-exclamation-triangle courses-attention" /> : null
                        // componentContext: {
                        //     count: props.state?.missingInfo
                        // }
                    }}
                    identifier={"courses-overview-missing-info"}
                    definition={{
                        ...CourseOverviewDefinitionMissingInformation,
                        columns: disableState(CourseOverviewDefinitionMissingInformation.columns.filter((c) => multipleTrainers || c.columnIdentifier !== "trainer_name"))
                        // topbar: CourseOverviewDefinitionMissingInformation.topbar.filter(s => multipleTrainers || s.columnIdentifier !== "trainer_name")
                    }}
                    contextData={{
                        trainers: props?.state?.filterTrainers,
                        // account_managers: props?.state?.filterAccountManagers,
                        // instructors: props?.state?.filterInstructors,
                        // locations: props?.state?.locations,
                        missingInfo: props?.state?.missingInfo
                    }}
                    forceFilter={filters
                        .filter((f) => f?.resultObj?.columnIdentifier /*&& f?.resultObj?.result*/)
                        .map((f) => {
                            return {
                                columnIdentifier: f?.resultObj?.columnIdentifier,
                                value: f?.resultObj?.result
                            };
                        })}
                />
            </Quickview>
        </>
    );
}
